
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Textresponsive3411083545",
      {"classes":{"root":"Textresponsive3411083545__root","size-tiny":"Typographyresponsive1941863919__size-tiny","size-small":"Typographyresponsive1941863919__size-small","size-medium":"Typographyresponsive1941863919__size-medium","size-large":"Typographyresponsive1941863919__size-large"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  